import React, { useState, useEffect } from "react";
import { Input, Select, Space, Table, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
const { Text } = Typography;

const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

const TableCustom = ({
  rowKey,
  loading,
  columns,
  disabled,
  dataSource,
  size,
  expandable,
  bordered,
  extraHeaderComponents,
  showSearch = true,
  onSearch,
  searchValue,
  onRowChangeSelect,
  isRowSelection,
  selectedRows,
  rowSelectionType,
  headerAlignItems,
  showCsv = true,
  csvTitle,
  summary,
  rowClassName,
  className = "",
}) => {
  const [columnsFilter, setColumnsFilter] = useState([]);
  const [search, setSearch] = useState("");
  const [marcado, setMarcado] = useState(0);

  useEffect(() => {
    renderColumns(columns);
  }, [columns]);

  useEffect(() => {
    setSearch(searchValue ?? "");
  }, [searchValue]);

  const renderColumns = (columns) => {
    let array_columns = [];
    for (let index = 0; index < columns?.length; index++) {
      array_columns?.push({
        sorter: (a, b) =>
          a?.[columns?.[index]?.dataIndex]?.toString()?.localeCompare(b?.[columns?.[index]?.dataIndex]?.toString()),
        ...columns[index],
      });
    }
    setColumnsFilter(array_columns);
  };

  // PESQUISAR
  const renderHeader = (colunas) => {
    let header_array = [];
    for (let index = 0; index < colunas?.length; index++) {
      if (colunas[index]?.dataIndex?.toString() !== "acoes") {
        header_array.push({ label: colunas[index]?.title?.toString(), key: colunas[index]?.dataIndex?.toString() });
      }
    }
    return header_array;
  };

  const headers = columns?.length > 0 ? renderHeader(columns) : [];

  const filterData = (data, search, marcado) => {
    if (onSearch) return data;

    let filteredData = data?.filter((d) =>
      columns?.some((c) => {
        let cellValue = d[`${c?.dataIndex}`];
        cellValue = c?.renderText ? c?.renderText(d) : cellValue;

        const searchValue = search?.toString()?.toLowerCase();
        return cellValue?.toString()?.toLowerCase()?.includes(searchValue);
      })
    );

    if (isRowSelection) {
      switch (marcado) {
        case 1:
          filteredData = filteredData.filter((e) => {
            return selectedRows?.indexOf(e.id) === -1 ? false : true;
          });
          break;
        case 2:
          filteredData = filteredData.filter((e) => {
            return selectedRows?.indexOf(e.id) === -1 ? true : false;
          });
          break;
        default:
          break;
      }
    }

    return filteredData;
  };

  const prepareCsv = (data) => {
    if (!showCsv) return data;
    let filteredData = [];

    for (let d of data) {
      let row = {};
      for (let c of columns) {
        let cellValue = d[`${c?.dataIndex}`];
        cellValue = c?.renderText ? c?.renderText(d) : cellValue;
        row = { ...row, [c?.dataIndex]: cellValue?.toString() };
      }
      filteredData.push(row);
    }

    return filteredData;
  };

  const data_filter = dataSource?.length > 0 ? filterData(dataSource, search, marcado) : [];

  const csv_filter = dataSource?.length > 0 ? prepareCsv(data_filter) : [];

  // CHECK ROW
  const rowSelection = {
    type: rowSelectionType ?? "checkbox",
    disabled: true,
    selectedRowKeys: selectedRows ?? [],
    onSelectAll: (e) => {
      if (loading || disabled) return;
      let array = [];
      if (e === true) array = data_filter?.map((e) => e && e[rowKey ?? "id"]);
      onRowChangeSelect(
        array,
        data_filter,
        array.filter((e) => e)
      );
    },
    onSelect: (data, status, allChecked) => {
      if (loading || disabled) return;
      const array = allChecked?.map((e) => e && e[rowKey ?? "id"]);
      onRowChangeSelect(
        status ? [data[rowKey ?? "id"]] : [],
        [{ id: data[rowKey ?? "id"] }],
        array.filter((e) => e)
      );
    },
  };

  const title = () => (
    <Space wrap style={{ alignItems: headerAlignItems ?? "end", width: "100%" }}>
      {showSearch && (
        <Space direction="vertical" size={0}>
          <Text style={{ fontSize: 12 }} type="secondary">
            Pesquisar:
          </Text>

          <Input
            size="middle"
            value={search}
            onChange={(e) => {
              onSearch && onSearch(e?.target?.value);
              setSearch(e?.target?.value);
            }}
            maxLength={100}
            prefix={<SearchOutlined />}
            placeholder="Pesquisar..."
            allowClear
          />
        </Space>
      )}

      {isRowSelection && (
        <Space direction="vertical" size={0}>
          <Text style={{ fontSize: 12 }} type="secondary">
            Filtro Selecionados:
          </Text>

          <Select
            value={marcado}
            style={{ width: 180, maxWidth: "100%" }}
            onChange={(e) => setMarcado(e)}
            options={optionsFiltro}
          />
        </Space>
      )}

      {extraHeaderComponents ?? null}
    </Space>
  );

  return (
    <Table
      title={extraHeaderComponents || showSearch ? title : null}
      style={{ borderRadius: 50 }}
      rowClassName={rowClassName}
      rowSelection={isRowSelection && rowSelection}
      rowKey={rowKey ?? "id"}
      className={`styles.ant-table-content ${className}`}
      loading={loading}
      scroll={{ x: 700 }}
      bordered={bordered ?? true}
      columns={columnsFilter ?? []}
      dataSource={data_filter ?? []}
      expandable={expandable}
      size={size ?? "small"}
      summary={summary}
      footer={() => (
        <CSVLink
          filename={csvTitle ?? "relatorio_tabela.csv"}
          separator=";"
          headers={headers ? headers : []}
          data={csv_filter}>
          Exportar CSV
        </CSVLink>
      )}
      pagination={{
        position: ["bottomRight"],
        size: "default",
        showTotal: (total, range) => {
          return (
            <Text type="secondary">
              exibindo {range[0]} até {range[1]}, de {total} registros
            </Text>
          );
        },
      }}
    />
  );
};

export { TableCustom };
